import { render, staticRenderFns } from "./SchedulesConfig.vue?vue&type=template&id=bdbace86&scoped=true"
import script from "./SchedulesConfig.vue?vue&type=script&lang=js"
export * from "./SchedulesConfig.vue?vue&type=script&lang=js"
import style0 from "./SchedulesConfig.vue?vue&type=style&index=0&id=bdbace86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbace86",
  null
  
)

export default component.exports